import { LineItem } from '../LineItem';

import { OrderShippingPoint } from './OrderShippingPoint';

const TYPE = 'Order';

export class OrderLineItem extends LineItem {
  pickupStopSequenceNumber = 1;
  dropOffStopSequenceNumber = 2;
  originOverride?: OrderShippingPoint;
  destinationOverride?: OrderShippingPoint;

  constructor(opts?: Partial<OrderLineItem>) {
    super(opts);
    this.type = TYPE;

    if (opts?.originOverride != null) {
      this.originOverride = new OrderShippingPoint(opts.originOverride);
    }
    if (opts?.destinationOverride != null) {
      this.destinationOverride = new OrderShippingPoint(
        opts.destinationOverride,
      );
    }
  }

  static isOrderLineItem(lineItem: LineItem): lineItem is OrderLineItem {
    return lineItem.type === TYPE;
  }
}
